/** ARCHITECTURE §4. Every document is a private GCS object, served by signed URL only. */
export const DOCUMENT_KINDS = ["uploaded", "extract", "generated_report"];
/** Default retention for case documents (COMPLIANCE Constraint 4). */
export const DEFAULT_RETENTION_DAYS = 90;
/**
 * How to say a `kind` to a human.
 *
 * WHY THESE ARE STATEMENTS ABOUT WHO ADDED THE DOCUMENT. `kind` is not a label
 * anybody chooses. The API derives it from the uploader's role and deliberately
 * refuses to read it from the request (`kindForUploader` in
 * apps/api/src/documents/service.ts), because a client who could label their
 * identity scan `extract` would have handed it to a search agent. So the kind IS
 * the record of who added the document — at ROLE granularity, and role
 * granularity is all of it: the row's `uploadedBy` column is never sent to any
 * client, so no surface may name a person here.
 *
 * `extract` covers BOTH the assigned professional and the assigned search agent,
 * because kindForUploader maps both to it. The wording must not settle on either
 * one; picking "the attorney" would be stating something the data does not say.
 *
 * These live in the shared package rather than in a component so that an
 * attorney can read and correct them in one place (CLAUDE.md §7).
 */
export const DOCUMENT_KIND_LABELS = {
    uploaded: "Supplied by the client",
    extract: "Retrieved at the registry by the attorney or search agent on the case",
    /*
     * D2 (answered 2026-08-16): the opinion is the ATTORNEY'S and this platform is
     * the courier. This label used to read "Produced by TitleVerify when the
     * report was packaged", which pre-empted that decision toward
     * platform-as-product — it made the deliverable sound like ours.
     *
     * What is true, and all that is true: the platform ASSEMBLES the file. The
     * opinion inside it is the attorney's work, signed by them. "Assembled" is the
     * courier's verb; "produced" was the author's.
     */
    generated_report: "Assembled by TitleVerify from the attorney's signed opinion",
};
//# sourceMappingURL=document.js.map